/** Keep the UI and the generated preview manifest on the same release marker. */
export const PREVIEW_VERSION = 'Web 1.0.0 · 原版2026.11.05.5';
